import { apiRequest } from '../services/apiClient';

const BASE = '/gateway/api/ticket/working-hours';

const unwrap = (response) => response?.data ?? response;

const workingHoursService = {
  async getSchedule() {
    const response = await apiRequest(`${BASE}/schedule`, { method: 'GET' });
    return unwrap(response);
  },

  async saveSchedule(days) {
    const response = await apiRequest(`${BASE}/schedule`, {
      method: 'PUT',
      body: { days },
    });
    return unwrap(response);
  },

  async listHolidays({ fromDate, toDate } = {}) {
    const params = new URLSearchParams();
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    const qs = params.toString();
    const response = await apiRequest(`${BASE}/holidays${qs ? `?${qs}` : ''}`, { method: 'GET' });
    return unwrap(response);
  },

  async createHoliday(payload) {
    const response = await apiRequest(`${BASE}/holidays`, { method: 'POST', body: payload });
    return unwrap(response);
  },

  async updateHoliday(holidayId, payload) {
    const response = await apiRequest(`${BASE}/holidays/${holidayId}`, {
      method: 'PUT',
      body: payload,
    });
    return unwrap(response);
  },

  async updateHolidayStatus(holidayId, isActive) {
    const response = await apiRequest(`${BASE}/holidays/${holidayId}/status`, {
      method: 'PATCH',
      body: { isActive },
    });
    return unwrap(response);
  },

  async deleteHoliday(holidayId) {
    const response = await apiRequest(`${BASE}/holidays/${holidayId}`, { method: 'DELETE' });
    return unwrap(response);
  },
};

export default workingHoursService;
